<template>
  <div>
    <div class="dark-cover" :class="{ open: isSrchOpen }"></div>
    <div class="srch-area" :class="{ open: isSrchOpen }">
      <div class="srch-area--in">
        <search-box
          placeholdered="어떤 제품을 찾겠습니까?"
          class="srch-top"
          @search-data="searchProducts"
          :cleanInput="true"
        />
        <h2 class="srch-area--recom mt-2">추천</h2>
        <div class="srch-area--recom-list mt-2">
          <a
            @click.prevent="searchProducts(item)"
            href=""
            class="srch-area--a"
            v-for="item in recommendedProduct"
            :key="item"
            >#{{ item }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBox from '@/components/page/SearchBox.vue';
import productsList from '@/utils/productsList';

export default {
  components: { SearchBox },
  name: 'Srch',
  props: {
    isSrchOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      recommendedProduct: [],
    };
  },
  created() {
    this.recommendedProduct = productsList.RECOMMENDED_PRODUCTS;
  },
  methods: {
    searchProducts(searchWord) {
      this.$emit('close-box');
      this.$store.dispatch('search/set', { searchedName: searchWord });
      this.$router.push({ name: 'Srch', params: { searchWord } });
    },
  },
};
</script>
